import React from 'react';
const areas = ['Fault Isolation', 'Motors', 'Mechanical', 'Hydraulics', 'Pneumatics', 'Controls'];
const features = ['Visual diagnostic maps', 'Troubleshooting sequences', 'Inspection checklists', 'Fault-isolation tools', 'Decision trees', 'Professional field references'];
export function SystemSection() {
  return <section className="bg-tech px-4 py-4 sm:py-6" data-id="element-165" data-mp="36lwicv7rghm4">
      <div className="mx-auto max-w-4xl" data-id="element-166" data-mp="31kz06imr3nkm">
        <h2 className="text-center text-lg leading-tight text-navy sm:text-3xl" data-id="element-167" data-mp="31m0gp2mjd29q">
          THE COMPLETE 6-IN-1 TROUBLESHOOTING SYSTEM
        </h2>
        <p className="mt-1 text-center font-head text-base font-bold uppercase tracking-wide text-navy sm:text-xl" data-id="element-168" data-mp="2srvsys2p86yf">
          🔧 INDUSTRIAL MAINTENANCE DIAGNOSTIC PRO™
        </p>

        <ul className="mt-1.5 flex flex-wrap items-center justify-center gap-x-2 gap-y-1" data-id="element-169" data-mp="2iu7tjou5eb9x">
          {areas.map(area => <li key={area} className="font-head text-[12px] font-bold uppercase tracking-wide text-steel sm:text-sm" data-id="element-170" data-mp="2duuzaj0y61xb">
              {area}
              <span className="ml-2 text-volt" aria-hidden="true" data-id="element-171" data-mp="18poev4neyshk">
                •
              </span>
            </li>)}
        </ul>

        <ul className="mt-2 grid gap-1 sm:grid-cols-2" data-id="element-172" data-mp="u2lfstjg0bs4">
          {features.map(feature => <li key={feature} className="rounded-md border border-navy/10 bg-white px-2.5 py-1.5 text-[13px] font-semibold leading-snug text-navy shadow-sm" data-id="element-173" data-mp="z0mvd4hntsyu">
              <span className="text-volt" data-id="element-174" data-mp="1roafyjixkjlh">✔</span> {feature}
            </li>)}
        </ul>
      </div>
    </section>;
}